import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=02f79280&scoped=true&"
import script from "./ChatBox.vue?vue&type=script&lang=ts&"
export * from "./ChatBox.vue?vue&type=script&lang=ts&"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=02f79280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f79280",
  null
  
)

export default component.exports